let facetFiltersGlobal = [];

// handles sidecart
const Sidecart = (() => {
  const sidecart = document.getElementById("side-cart");
  const overlay = document.getElementById("side-cart-overlay");

  if (!sidecart) return;

  const lineItemsWrapper = sidecart.querySelector(".side-cart-items-wrapper");
  const lineItems = Array.from(sidecart.querySelectorAll(".side-cart-item"));
  const sidecartHeader = sidecart.querySelector(".side-cart-header");
  const emptyStateElement =
    sidecart.querySelector("[data-side-cart-empty]") || null;

  const quantityContainer = document.getElementById("side-cart-items-quantity");
  const priceContainer = document.getElementById("side-cart-total-price");
  const subtotalContainer = document.getElementById("side-cart-subtotal");
  const cartCountContainer = document.querySelector(".cart-count-bubble");
  const giftWrapToggle = sidecart.querySelector("#side-cart-gift-wrap-toggle");
  const mobileSidecartQuery = window.matchMedia("(max-width: 749px)");

  const initialSubtotalCents = subtotalContainer
    ? Number(subtotalContainer.getAttribute("data-side-cart-subtotal-cents"))
    : NaN;
  const initialSubtotalText = priceContainer
    ? priceContainer.textContent
    : subtotalContainer
      ? subtotalContainer.textContent
      : "";
  let totalPrice = Number.isFinite(initialSubtotalCents)
    ? initialSubtotalCents
    : Number(String(initialSubtotalText || "").replace(/[^\d]/g, "")) || 0;
  let swipeTouchId = null;
  let swipeStartY = 0;
  let swipeCurrentY = 0;
  let swipeStartAt = 0;
  let isSwipingSidecart = false;
  let giftWrapInFlight = false;
  let syncingGiftWrapToggle = false;

  const swipeCloseThresholdPx = 96;
  const swipeCloseVelocityThreshold = 0.45;

  function getSidecartItemCount() {
    return sidecart.querySelectorAll("[data-side-cart-item-id]").length;
  }

  function syncSidecartEmptyState(itemCount) {
    const resolvedCount = Number.isFinite(itemCount)
      ? itemCount
      : getSidecartItemCount();
    const isEmpty = resolvedCount <= 0;

    if (emptyStateElement) {
      emptyStateElement.hidden = !isEmpty;
    }

    if (giftWrapToggle) {
      giftWrapToggle.disabled = isEmpty;
    }
  }

  function setSidecartSubtotal(amountInCents) {
    if (!subtotalContainer) return;
    const normalizedAmount = Number.isFinite(amountInCents) ? amountInCents : 0;
    subtotalContainer.textContent = Shopify.formatMoney(normalizedAmount);
  }

  function syncGiftWrapFromAttributes(attributes) {
    if (!giftWrapToggle) return;
    const giftWrapValue =
      attributes && typeof attributes === "object"
        ? String(attributes["Gift wrap"] || "").toLowerCase()
        : "";
    const isEnabled =
      giftWrapValue === "yes" ||
      giftWrapValue === "true" ||
      giftWrapValue === "1";
    syncingGiftWrapToggle = true;
    giftWrapToggle.checked = isEnabled;
    syncingGiftWrapToggle = false;
  }

  function updateGiftWrapAttribute(checked) {
    if (!giftWrapToggle || giftWrapInFlight) return;
    const previousChecked = giftWrapToggle.checked;
    giftWrapInFlight = true;
    giftWrapToggle.disabled = true;

    const body = JSON.stringify({
      attributes: {
        "Gift wrap": checked ? "Yes" : "",
      },
    });

    fetch(routes.cart_update_url, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        const subtotal =
          Number.isFinite(state.items_subtotal_price) && state.items_subtotal_price >= 0
            ? state.items_subtotal_price
            : state.total_price;
        setSidecartSubtotal(subtotal);
        syncGiftWrapFromAttributes(state.attributes);
      })
      .catch(() => {
        syncingGiftWrapToggle = true;
        giftWrapToggle.checked = previousChecked;
        syncingGiftWrapToggle = false;
      })
      .finally(() => {
        giftWrapInFlight = false;
        giftWrapToggle.disabled = false;
      });
  }

  function canSwipeCloseSidecart() {
    return mobileSidecartQuery.matches && sidecart.classList.contains("visible");
  }

  function getTrackedTouch(touchList) {
    if (swipeTouchId == null) return null;
    for (let i = 0; i < touchList.length; i += 1) {
      if (touchList[i].identifier === swipeTouchId) {
        return touchList[i];
      }
    }
    return null;
  }

  function resetSwipeState() {
    swipeTouchId = null;
    swipeStartY = 0;
    swipeCurrentY = 0;
    swipeStartAt = 0;
    isSwipingSidecart = false;
  }

  function clearSwipeStyles() {
    sidecart.style.transform = "";
    sidecart.style.transition = "";
  }

  function handleSwipeStart(event) {
    if (!canSwipeCloseSidecart()) return;
    if (!event.touches || event.touches.length !== 1) return;

    const touch = event.touches[0];
    swipeTouchId = touch.identifier;
    swipeStartY = touch.clientY;
    swipeCurrentY = touch.clientY;
    swipeStartAt = Date.now();
    isSwipingSidecart = true;

    sidecart.style.transition = "none";
  }

  function handleSwipeMove(event) {
    if (!isSwipingSidecart || swipeTouchId == null) return;
    const touch = getTrackedTouch(event.touches);
    if (!touch) return;

    swipeCurrentY = touch.clientY;
    const deltaY = Math.max(0, swipeCurrentY - swipeStartY);
    if (deltaY <= 0) return;

    sidecart.style.transform = `translateY(${deltaY}px)`;
    event.preventDefault();
  }

  function handleSwipeEnd(event) {
    if (!isSwipingSidecart || swipeTouchId == null) return;

    const touch =
      getTrackedTouch(event.changedTouches || []) ||
      getTrackedTouch(event.touches || []);

    const endY = touch ? touch.clientY : swipeCurrentY;
    const distance = Math.max(0, endY - swipeStartY);
    const elapsed = Math.max(1, Date.now() - swipeStartAt);
    const velocity = distance / elapsed;

    const shouldClose =
      distance >= swipeCloseThresholdPx || velocity >= swipeCloseVelocityThreshold;

    resetSwipeState();

    if (shouldClose) {
      clearSwipeStyles();
      setAsHidden();
      return;
    }

    sidecart.style.transition = "transform 220ms cubic-bezier(0.22, 1, 0.36, 1)";
    sidecart.style.transform = "";
    window.setTimeout(() => {
      sidecart.style.transition = "";
    }, 240);
  }

  // update item quantity in the sidecart
  const updateQuantity = (id, quantity, name, currentItem) => {
    currentItem.dataset.isLoading = "true";

    if (name) {
      quantity = Number(currentItem.dataset.sideCartItemQuantity);

      if (name === "plus") {
        quantity += 1;
      } else if (name === "minus") {
        quantity -= 1;
      } else {
        quantity = 0;
      }
    }

    const body = JSON.stringify({
      id,
      quantity,
    });

    fetch(routes.cart_change_url, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((state) => {
        currentItem.dataset.isLoading = "false";

        const cannotAddMoreItemsContainer = currentItem.querySelector(
          ".side-cart-cannot-add-more-items"
        );

        if (name === "remove" || quantity === 0) {
          currentItem.remove();
        } else {
          const item = state.items.find(
            (r) => currentItem.dataset.sideCartItemId === r.key
          );
          if (!item) return;

          const priceHolders = currentItem.querySelectorAll(
            ".side-cart-item-price"
          );
          const input = currentItem.querySelector("input");

          priceHolders.forEach((priceHolder) => {
            priceHolder.textContent = Shopify.formatMoney(
              item.price * item.quantity
            );
          });

          input.value = item.quantity;
          currentItem.dataset.sideCartItemQuantity = item.quantity;

          if (
            quantity > item.quantity &&
            cannotAddMoreItemsContainer.classList.contains("hidden")
          ) {
            cannotAddMoreItemsContainer.classList.remove("hidden");
            setTimeout(
              () => cannotAddMoreItemsContainer.classList.add("hidden"),
              3000
            );
          }
        }

        totalPrice = state.items_subtotal_price;

        const q = state.item_count;
        syncSidecartEmptyState(q);
        setSidecartSubtotal(state.items_subtotal_price);
        syncGiftWrapFromAttributes(state.attributes);

        if (quantityContainer) quantityContainer.textContent = q;

        if (cartCountContainer) {
          if (q <= 0) {
            if (!cartCountContainer.classList.contains("hidden")) {
              cartCountContainer.classList.add("hidden");
            }
            cartCountContainer.textContent = "0";
          } else {
            if (cartCountContainer.classList.contains("hidden")) {
              cartCountContainer.classList.remove("hidden");
            }
            cartCountContainer.textContent = q;
          }
        }
        if (priceContainer) priceContainer.textContent = Shopify.formatMoney(totalPrice);

        if (q <= 0 && canSwipeCloseSidecart()) {
          setAsHidden();
        }
      });
  };

  const addNewItem = (newItem) => {
    const itemId = newItem.key;
    const itemQuantity = newItem.quantity;

    const item = document.createElement("div");
    item.classList.add("side-cart-item");
    item.dataset.sideCartItemId = itemId;
    item.dataset.sideCartItemQuantity = itemQuantity;
    item.dataset.isLoading = "false";

    const itemPrice = newItem.price * itemQuantity;
    const formattedItemPrice = Shopify.formatMoney(itemPrice);

    if (sidecart.classList.contains("side-cart--v2")) {
      item.innerHTML = `
      <figure class="side-cart-item-figure">
          <img
            src="${newItem.featured_image.url}"
            alt="${newItem.featured_image.alt}"
            loading="lazy"
            width="80"
            height="${Math.ceil(80 / newItem.featured_image.aspect_ratio)}"
          >
      </figure>

      <section class="side-cart-item-details">
          <div class="side-cart-item-title-and-remove-button">
              <p class="side-cart-item-price">
                  <span>${formattedItemPrice}</span>
              </p>

              <button class="side-cart-item-remove" type="button">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 2V0H15V2H20V4H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V4H0V2H5ZM4 4V18H16V4H4ZM7 7H9V15H7V7ZM11 7H13V15H11V7Z" fill="#1E1E1E"/>
                  </svg>
              </button>
          </div>
          <a href="${newItem.url}" class="side-cart-item-title">
            ${newItem.product_title}
          </a>

          <div class="side-cart-item-meta">
            ${
              !newItem.product_has_only_default_variant
                ? newItem.options_with_values
                    .map(
                      (option) =>
                        `<dl>
                          <dt>${option.name}:&nbsp;</dt>
                          <dd>${option.value}</dd>
                        </dl>`
                    )
                    .join("")
                : ""
            }
            <dl>
              <dt>Qty:&nbsp;</dt>
              <dd>${newItem.quantity}</dd>
            </dl>
          </div>
      </section>
    `.trim();
    } else {
      item.innerHTML = `
      <figure class="side-cart-item-figure">
          <img
            src="${newItem.featured_image.url}"
            alt="${newItem.featured_image.alt}"
            loading="lazy"
            width="80"
            height="${Math.ceil(80 / newItem.featured_image.aspect_ratio)}"
          >
      </figure>

      <section class="side-cart-item-details">
          <div class="side-cart-item-title-and-remove-button">
              <a href="${newItem.url}" class="side-cart-item-title">
                  ${newItem.product_title}
              </a>

              <button class="side-cart-item-remove" type="button">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 2V0H15V2H20V4H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V4H0V2H5ZM4 4V18H16V4H4ZM7 7H9V15H7V7ZM11 7H13V15H11V7Z" fill="#1E1E1E"/>
                  </svg>
              </button>
          </div>

          <p class="side-cart-item-price side-cart-visible-on-phone">
            ${formattedItemPrice}
          </p>

          ${
            !newItem.product_has_only_default_variant
              ? newItem.options_with_values
                  .map(
                    (option) =>
                      `<dl><dt>${option.name}:&nbsp;</dt><dd>${option.value}</dd></dl>`
                  )
                  .join("")
              : ""
          }

          <dl class="side-cart-cannot-add-more-items hidden">
            <dt>Cannot&nbsp;</dt>
            <dd>add more of this item.</dd>
          </dl>

          <div class="side-cart-item-quantity-and-price">
              <div class="side-cart-item-quantity-container">
                  <button name="minus" type="button">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="40" height="40" rx="10" fill="#F5F5F5"/>
                          <path d="M13 20H27" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </button>

                  <input
                    type="number"
                    name="updates[]"
                    value="${newItem.quantity}"
                    min="0"
                  >

                  <button name="plus" type="button">
                      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="40" height="40" rx="10" fill="#F5F5F5"/>
                          <path d="M20 13V27" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M13 20H27" stroke="#1E1E1E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </button>
              </div>

              <p class="side-cart-item-price side-cart-hidden-on-phone">${formattedItemPrice}</p>
          </div>
      </section>
    `.trim();
    }

    lineItemsWrapper.prepend(item);

    const plusButton = item.querySelector('button[name="plus"]');
    const minusButton = item.querySelector('button[name="minus"]');
    const itemQuantityInput = item.querySelector('input[name="updates[]"]');
    const removeButton = item.querySelector(".side-cart-item-remove");

    const q = Number(quantityContainer ? quantityContainer.textContent : 0) + itemQuantity;

    if (quantityContainer) {
      quantityContainer.textContent = q;
    }

    if (cartCountContainer) {
      if (cartCountContainer.classList.contains("hidden")) {
        cartCountContainer.classList.remove("hidden");
      }
      cartCountContainer.textContent = q;
    }

    let newTotalPrice = Number(totalPrice || 0) + Number(itemPrice || 0);
    totalPrice = newTotalPrice;
    if (priceContainer) priceContainer.textContent = Shopify.formatMoney(newTotalPrice);
    setSidecartSubtotal(newTotalPrice);
    syncSidecartEmptyState(q);

    if (plusButton) {
      plusButton.addEventListener("click", () =>
        updateQuantity(itemId, itemQuantity, "plus", item)
      );
    }
    if (minusButton) {
      minusButton.addEventListener("click", () =>
        updateQuantity(itemId, itemQuantity, "minus", item)
      );
    }
    if (removeButton) {
      removeButton.addEventListener("click", () =>
        updateQuantity(itemId, 0, "remove", item)
      );
    }
    if (itemQuantityInput) {
      itemQuantityInput.addEventListener("input", () =>
        updateQuantity(itemId, Number(itemQuantity.value), undefined, item)
      );
    }
  };

  // show sidecart
  const setAsVisible = (state) => {
    if (state) {
      const existingItems = Array.from(
        sidecart.querySelectorAll("[data-side-cart-item-id]")
      );
      const existingItem = existingItems.find(
        (item) => item.dataset.sideCartItemId === state.key
      );

      if (existingItem) {
        const input = existingItem.querySelector('input[name="updates[]"');
        const finalPrices = existingItem.querySelectorAll(
          ".side-cart-item-price"
        );
        const formattedItemPrice = Shopify.formatMoney(
          state.price * state.quantity
        );

        if (input) input.value = state.quantity;
        
        existingItem.dataset.sideCartItemQuantity = state.quantity;
        finalPrices.forEach((finalPrice) => {
          finalPrice.textContent = formattedItemPrice;
        });

        totalPrice += state.price;

        const q = Number(quantityContainer ? quantityContainer.textContent : 0) + 1;

        if (quantityContainer) quantityContainer.textContent = q;

        if (cartCountContainer) {
          if (cartCountContainer.classList.contains("hidden")) {
            cartCountContainer.classList.remove("hidden");
          }
  
          cartCountContainer.textContent = q;
        }
        if (priceContainer) priceContainer.textContent = Shopify.formatMoney(totalPrice);
        setSidecartSubtotal(totalPrice);
      } else {
        addNewItem(state);
      }
    }

    syncSidecartEmptyState();
    document.body.style.overflow = "hidden";
    clearSwipeStyles();
    sidecart.classList.add("visible");
    overlay.classList.add("visible");
  };

  // hide sidecart
  const setAsHidden = () => {
    document.body.style.overflow = "auto";
    clearSwipeStyles();
    resetSwipeState();
    sidecart.classList.remove("visible");
    overlay.classList.remove("visible");
  };

  // toggle the visibility of the sidecart
  const toggleVisibility = () => {
    if (sidecart.classList.contains("visible")) {
      setAsHidden();
      return;
    }
    setAsVisible();
  };

  // set all event listeners for the side cart
  const setEventListeners = () => {
    // remove sidecart from overlay click handler
    overlay.addEventListener("click", setAsHidden);

    lineItems.forEach((item) => {
      const plusButton = item.querySelector('button[name="plus"]');
      const minusButton = item.querySelector('button[name="minus"]');
      const itemQuantityInput = item.querySelector('input[name="updates[]"]');
      const removeButton = item.querySelector(".side-cart-item-remove");

      const itemId = item.dataset.sideCartItemId;
      const itemQuantity = Number(item.dataset.sideCartItemQuantity);

      if (plusButton) {
        plusButton.addEventListener("click", () =>
          updateQuantity(itemId, itemQuantity, "plus", item)
        );
      }
      if (minusButton) {
        minusButton.addEventListener("click", () =>
          updateQuantity(itemId, itemQuantity, "minus", item)
        );
      }
      if (removeButton) {
        removeButton.addEventListener("click", () =>
          updateQuantity(itemId, 0, "remove", item)
        );
      }
      if (itemQuantityInput) {
        itemQuantityInput.addEventListener("input", () =>
          updateQuantity(itemId, Number(itemQuantity.value), undefined, item)
        );
      }
    });

    // remove line item handler
    const sidecartRemoveButton = sidecart.querySelector("#side-cart-remove");
    sidecartRemoveButton.addEventListener("click", setAsHidden);

    if (sidecartHeader) {
      sidecartHeader.addEventListener("touchstart", handleSwipeStart, {
        passive: true,
      });
      sidecartHeader.addEventListener("touchmove", handleSwipeMove, {
        passive: false,
      });
      sidecartHeader.addEventListener("touchend", handleSwipeEnd, {
        passive: true,
      });
      sidecartHeader.addEventListener("touchcancel", handleSwipeEnd, {
        passive: true,
      });
    }

    if (giftWrapToggle) {
      giftWrapToggle.addEventListener("change", () => {
        if (syncingGiftWrapToggle) return;
        updateGiftWrapAttribute(giftWrapToggle.checked);
      });
    }

    syncSidecartEmptyState();
    setSidecartSubtotal(Number.isFinite(totalPrice) ? totalPrice : 0);
  };

  return {
    setEventListeners,
    updateQuantity,
    setAsVisible,
    setAsHidden,
    toggleVisibility,
  };
})();

/**
 * Handles the width of an element relatively to the scroll position
 * @param {HTMLDivElement} element
 */
function maximizeElementWidthOnScroll(element) {
  if (!element) return;

  // shopify header
  const header = document.getElementById("shopify-section-header");

  window.scroll(0, 0);

  // returns element's relative position to top scroll position
  function getElementScrollTop() {
    return element.getBoundingClientRect().top;
  }
  // initial element position relative to top scroll;
  const initialElementScrollTop = getElementScrollTop();
  // width to reach eventually
  const awaitedWidth = document.body.offsetWidth;
  // padding to reach eventually
  const awaitedPadding = 0;
  // current element width
  const currentWidth = element.clientWidth;
  // current element padding
  const currentPadding = Number(
    getComputedStyle(element)
      ?.getPropertyValue("padding")
      ?.split(" ")[1]
      ?.replace("px", "") ?? 0
  );
  // offset of both widths
  const offsetWidth = Math.abs(awaitedWidth - currentWidth);
  // offset of both paddings
  const offsetPadding = Math.abs(awaitedPadding - currentPadding);
  // remove element max width if available
  element.style.maxWidth = "unset";

  const handleElementScrollPosition = () => {
    setTimeout(() => {
      const currentElementScrollTop = getElementScrollTop();

      const x = initialElementScrollTop / currentElementScrollTop;

      const resultWidth = Math.abs(awaitedWidth - offsetWidth / x);
      const paddingResult = Math.abs(awaitedPadding - offsetPadding / x);

      element.style.width = resultWidth + "px";
      element.style.padding = `0 ${paddingResult}px`;

      if (!header.classList.contains("shopify-section-header-hidden")) {
        element.style.top = header.offsetHeight + "px";
      } else {
        element.style.top = "0";
      }
    }, 5);
  };
  handleElementScrollPosition();
  window.addEventListener("scroll", handleElementScrollPosition);
}

/**
 * Handles if an element exists in the viewport on scroll
 * @param {(entry: IntersectionObserverEntry) => any} callback
 */
function ElementVisilibityObserver(callback) {
  return new IntersectionObserver((entries) => callback(entries[0]), {
    threshold: [0],
  });
}

// custom functions

function handleNavigationBarCollectionDropdownPosition() {
  const { offsetHeight: announcementBarHeight } = document.getElementById(
    "shopify-section-announcement-bar"
  ) || { offsetHeight: 0 };
  const { offsetHeight: headerHeight } = document.getElementById("shopify-section-header") || document.getElementById("shopify-section-header-v2");
  const dropdowns = document.querySelectorAll(
    ".header__inline-menu details > .header__submenu"
  );

  const height = announcementBarHeight + headerHeight;

  dropdowns.forEach((dropdown) => {
    dropdown.style.top = height - 1 + "px";
  });
}

function handleCollectionAnchorTags() {
  const as = document.querySelectorAll("a");

  as.forEach((a) => {
    const href = a.href;

    const lastSlashIndex = href.lastIndexOf("/");
    const collectionIndex = href.indexOf("collection");

    const isCollection =
      collectionIndex > -1 && collectionIndex < lastSlashIndex;
    const hasQuestionMark = href.includes("?");
    const hasAmpersand = href.includes("&");
    const isToClearFilters = a.dataset.clearFilters === "true";

    if (
      isCollection &&
      !hasQuestionMark &&
      !hasAmpersand &&
      !isToClearFilters
    ) {
      a.href = href + "?filter.v.availability=1";
    }
  });
}

// handles facets collection filter bar animation
function handleCollectionFacetAnimationOnScroll() {
  const splitPath = location.pathname.split("/").filter((r) => r !== "");

  const mainCollectionFilters = document.getElementById(
    "main-collection-filters"
  );

  if (
    splitPath.length > 1 &&
    splitPath.includes("collections") &&
    mainCollectionFilters
  ) {
    maximizeElementWidthOnScroll(mainCollectionFilters);
  }
}

// handle fade-in animation on scroll in the homepage
function handleIfHomepageSectionExistsOnScreen() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll("#MainContent > *");

    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-from-${scrollingFrom.top ? "top" : "bottom"}`;

        shownSections.push(entry.target);
        entry.target.classList.add(_class);
        setTimeout(() => {
          entry.target.classList.remove(_class);
        }, 1000);
      } else {
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);

      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// handle fade-in animation on scroll in the homepage
function handleIfHomepageSingleScreen() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const sections = document.querySelectorAll('[data-single-anmation="top-bottom"]');
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        // const _class = `fade-in-from-${scrollingFrom.top ? "top" : "bottom"}`;

        shownSections.push(entry.target);
        // entry.target.classList.add(_class);
        setTimeout(() => {
          console.log(entry.target.dataset);
          // entry.target.classList.remove(_class);
          entry.target.removeAttribute('data-single-anmation');
          console.log(entry.target.dataset);
        }, 1000);
      } else {
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      const observer = ElementVisilibityObserver(ElementVisilibityObserverCallback);
      observer.observe(section);
      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// make custom video responsive
function handleCustomVideoResponsiveness() {
  const videos = document.querySelectorAll(".custom-video-section > video");

  if (!videos || videos.length < 1) return;

  function handleVideos() {
    videos.forEach((video) => {
      const desktopVideo = video.dataset.desktopVideoUrl;
      let phoneVideo = video.dataset.phoneVideoUrl;

      if (!phoneVideo || phoneVideo.length < 1) phoneVideo = desktopVideo;

      if (window.innerWidth <= 750) {
        if (video.src !== phoneVideo) video.src = phoneVideo;
      } else {
        if (video.src !== desktopVideo) video.src = desktopVideo;
      }
    });
  }

  handleVideos();
  window.addEventListener("resize", handleVideos);
}

// add quick view to product card
function handleProductQuickView() {
  const productCards = document.querySelectorAll(".product-card-link-wrapper");

  if (!productCards?.length) return;

  const fetchedProducts = [];

  /**
   * @param {Event} e
   */
  const onClick = (e, productHandle, variantQuantities, variantColors) => {
    e.preventDefault();
    e.stopPropagation();

    if (window.innerWidth <= 750) {
      if (!e.currentTarget.classList.contains("visible")) {
        e.currentTarget.classList.add("visible");
        return;
      }
    }

    let fetchedProduct = fetchedProducts.find(
      (r) => r.handle === productHandle
    );

    if (!fetchedProduct) {
      handleQuickViewElement();

      fetch(`${Shopify.routes.root}products/${productHandle}.js`)
        .then((res) => res.json())
        .then((res) => {
          fetchedProduct = res;
          fetchedProducts.push(fetchedProduct);
          handleQuickViewElement(res, variantQuantities, variantColors);
        });
    } else {
      handleQuickViewElement(fetchedProduct, variantQuantities, variantColors);
    }
  };

  productCards.forEach((productCard) => {
    const productHandle = productCard.dataset.productHandle;
    const variantQuantities = productCard.dataset.variantQuantities;
    const variantColors = productCard.dataset.variantColors;
    const overlay = productCard.querySelector(".quick-view-hover-overlay");
    if (!overlay) return;
    const overlays = document.querySelectorAll(
      ".product-card-link-wrapper .quick-view-hover-overlay"
    );

    overlay.addEventListener("click", (e) => {
      overlays.forEach((o) => {
        if (o !== overlay && o.classList.contains("visible"))
          o.classList.remove("visible");
      });

      onClick(e, productHandle, variantQuantities, variantColors);
    });
  });

  function handleQuickViewElement(product, variantQuantities, variantColors) {
    const container = document.createElement("div");
    container.className = "product-quick-view-wrapper";

    const overlay = document.createElement("div");
    overlay.className = "product-quick-view-overlay";
    overlay.addEventListener("click", removeElement);

    if (!!product) {
      const isToPreorder = product.tags.includes("preorder");
      let selectedVariantId = product.variants[0].id;
      let quantity = 1;
      let color = null;

      const q = variantQuantities.split(",");
      const colors = variantColors.split(",");
      product.variants = product.variants.map((variant, i) => ({
        ...variant,
        quantity: Number(q[i]),
        color: colors[i],
      }));

      function renderChildVariants(options, variants, parentOption, parent) {
        const fetchPossibilities = (arr1, arr2) => {
          const temp = [];

          arr1.forEach((i) => {
            arr2?.forEach((j) => {
              temp.push([i, j]);
            });
          });

          return arr2 ? temp : arr1;
        };

        const possibilities = fetchPossibilities(
          options[0]?.values,
          options[1]?.values
        );

        let selectedVariants = [];
        const sizes = getSortingSizes();

        possibilities.forEach((possibility) => {
          variants.forEach((variant) => {
            if (
              variant.options.toString() === possibility.toString() &&
              variant.options[0] === parentOption
            ) {
              let index = sizes.findIndex(
                (r) =>
                  String(r.size).toLowerCase() ===
                  variant?.options[1]?.toLowerCase()
              );

              if (index < 0) {
                index = sizes.findIndex(
                  (r) =>
                    r?.alias?.toLowerCase() === variant?.options[1]?.toLowerCase()
                );
              }

              selectedVariants.push({ index, variant });
            }
          });
        });

        let isSelected = false;
        selectedVariants
          .sort((a, b) => a.index - b.index)
          .forEach(({ index, variant: { quantity, id, ...variant } }) => {
            let hoverable = "";

            if (quantity === 1) {
              hoverable = `<span class="hoverable">One Left</span>`;
            } else if (quantity < 5 && quantity > 1) {
              hoverable = `<span class="hoverable">Low Stock</span>`;
            }

            const dd = document.createElement("dd");
            if (quantity === 0) dd.classList.add("disabled");
            if (!variant?.option2) dd.classList.add("visually-hidden");
            dd.innerHTML = `<span>${
              sizes[index]?.alias || variant?.option2 || ""
            }</span>${hoverable}`;

            if (quantity > 0 && !isSelected) {
              isSelected = true;
              selectedVariantId = id;
              dd.classList.add("selected");
            }

            if (!selectedVariantId) {
              selectedVariantId = id;
            }

            dd.addEventListener("click", () => {
              const dds = parent.querySelectorAll("dd");
              dds.forEach((r) => r.classList.remove("selected"));

              selectedVariantId = id;
              dd.classList.add("selected");
            });

            parent.appendChild(dd);
          });

        const addToCartButton = container.querySelector(
          ".product-quick-view-add-to-cart"
        );
        if (!isSelected) {
          addToCartButton.setAttribute("disabled", "true");
        } else {
          addToCartButton.removeAttribute("disabled");
        }

        const featuredImage =
          selectedVariants.filter((r) => r?.variant?.featured_image)[0]?.variant?.featured_image ||
          product.media.sort((a, b) => a.position - b.position)[0];

        const imgElement = container.querySelector("#main-image-container");
        imgElement.src = featuredImage?.src || imgElement.src;
      }

      const productMedia = product.media.sort(
        (a, b) => a.position - b.position
      );
      const firstImage = productMedia[0];
      // Variant color get
      let parrentOptionColors = []; 
      product.options[0].values.forEach(
        (r, i) => {
          const variants = product.variants;
          for (let v = 0; v < variants.length; v++) {
            const variant = variants[v];
            if (variant.option1.toLowerCase() == r.toLowerCase()) {
              if (variant.color != "null" && variant.color == "data" ) {
                parrentOptionColors.push(`<dd class="${i === 0 ? "selected" : ""} color-selector" data-option="${r.trim()}"><div style="background: ${variant.color}">&nbsp;</div></dd>`);
              } else {
                parrentOptionColors.push(`<dd class="${i === 0 ? "selected" : ""}" data-option="${r.trim()}">${r.trim()}</dd>`);
              }
              break;
            }
          }
        });

      let getWishlistBtn = document.querySelector(`[data-product_id="${product.id}"]`);
      container.innerHTML = `
        <section class="hide-quick-view-container">
          <p>PRODUCT QUICKVIEW</p>

          <button class="hide-quick-view">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="black"/>
            </svg>
          </button>
        </section>

        <p class="product-quick-view-title h4" style="display: none;">
          ${product.title}
        </p>

        <p class="product-quick-view-price"  style="display: none;">
          <span class="product-quick-view-price">
            ${Shopify.formatMoney(product.price)}
          </span>

          <span 
          class="product-quick-view-compare-at-price${
            product.price >= product.compare_at_price ? " hidden" : ""
          }"
          >
            ${Shopify.formatMoney(product.compare_at_price)}
          </span>
        </p>
  
        <section class="product-quick-view-images-container">
          <figure class="product-quick-view-main-image-container">
            <img 
              src="${firstImage.src}"
              alt="${firstImage.alt ?? ""}"
              width="300"
              height="${Math.ceil(300 / firstImage.aspect_ratio)}"
              id="main-image-container"
            >
          </figure>
  
          <div class="product-quick-view-sub-images-container${
            productMedia.length === 0 ? " hidden" : ""
          }">
            ${productMedia
              .map(
                (r) => `
                  <img 
                    src="${r.src}"
                    alt="${r.alt ?? ""}"
                  >`
              )
              .join("")}
          </div>
        </section>
  
        <section class="product-quick-view-details-container">
          <p class="product-quick-view-vendor gold">
            ${product.vendor}
          </p>

          <p class="product-quick-view-title h4">
            ${product.title}
          </p>
        
          <p class="product-quick-view-price">
             <span class="product-quick-view-price">
              ${Shopify.formatMoney(product.price)}
             </span>
  
             <span 
              class="product-quick-view-compare-at-price${
                product.price >= product.compare_at_price ? " hidden" : ""
              }"
             >
              ${Shopify.formatMoney(product.compare_at_price)}
             </span>
          </p>
  
          <dl class="parent-product-variants${
            product.options[0]?.name === "Title" ? " visually-hidden" : ""
          }">
              <dt>${product.options[0].name}</dt>
              ${parrentOptionColors.join("")}
          </dl>
  
          <dl class="child-product-variants">
              <dt>${product.options[1]?.name || ""}</dt>
          </dl>
  
          <p class="quick-view-error-message invisible">
              Cannot add more of this item.
          </p>
  
          <div class="product-quick-view-quantity-container">
              <button name="minus">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.1665 9.16797H15.8332V10.8346H4.1665V9.16797Z" fill="#787878"/>
                </svg>
              </button>
  
              <input type="number" min="1" value="1">
  
              <button name="plus">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.1665 9.16797V4.16797H10.8332V9.16797H15.8332V10.8346H10.8332V15.8346H9.1665V10.8346H4.1665V9.16797H9.1665Z" fill="#787878"/>
                </svg>
              </button>
          </div>
        </section>

        <section class="product-quick-view-navigation-buttons">
          <div class="product-quick-view-navigation-actions">
            <button class="product-quick-view-add-to-cart">
              <span>${
                isToPreorder ? "PREORDER" : window.variantStrings.addToCart
              }</span>
              &nbsp;
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.41667 1.66602H14.5833C14.7127 1.66602 14.8403 1.69614 14.956 1.75399C15.0717 1.81185 15.1724 1.89585 15.25 1.99935L17.5 4.99935V17.4993C17.5 17.7204 17.4122 17.9323 17.2559 18.0886C17.0996 18.2449 16.8877 18.3327 16.6667 18.3327H3.33333C3.11232 18.3327 2.90036 18.2449 2.74408 18.0886C2.5878 17.9323 2.5 17.7204 2.5 17.4993V4.99935L4.75 1.99935C4.82762 1.89585 4.92828 1.81185 5.04399 1.75399C5.1597 1.69614 5.2873 1.66602 5.41667 1.66602ZM15.8333 6.66602H4.16667V16.666H15.8333V6.66602ZM15.4167 4.99935L14.1667 3.33268H5.83333L4.58333 4.99935H15.4167ZM7.5 8.33268V9.99935C7.5 10.6624 7.76339 11.2983 8.23223 11.7671C8.70107 12.236 9.33696 12.4993 10 12.4993C10.663 12.4993 11.2989 12.236 11.7678 11.7671C12.2366 11.2983 12.5 10.6624 12.5 9.99935V8.33268H14.1667V9.99935C14.1667 11.1044 13.7277 12.1642 12.9463 12.9456C12.1649 13.727 11.1051 14.166 10 14.166C8.89493 14.166 7.83512 13.727 7.05372 12.9456C6.27232 12.1642 5.83333 11.1044 5.83333 9.99935V8.33268H7.5Z" fill="white"/>
              </svg>
            </button>
            <div id="quick-view-wishlist" class="th_prd_wl_btn" data-product_id="${product.id}" data-variant_id="${selectedVariantId ? selectedVariantId : null}">
              ${getWishlistBtn ? getWishlistBtn.innerHTML : null}
            </div>
            
            
          </div>
          <a href="${product.url}">
              VIEW DETAILS
          </a>
        </section>
      `;

      container
        .querySelectorAll(".product-quick-view-sub-images-container")
        .forEach((img) => {
          img.addEventListener("click", (e) => {
            container.querySelector("#main-image-container").src = e.target.src;
          });
        });

      handleEventListeners();
      renderChildVariants(
        product.options,
        product.variants,
        product.options[0].values[0],
        container.querySelector(".child-product-variants")
      );

      function handleEventListeners() {
        const parentVariants = container.querySelectorAll(
          ".parent-product-variants > dd"
        );
        const minusButton = container.querySelector('button[name="minus"]');
        const plusButton = container.querySelector('button[name="plus"]');
        const input = container.querySelector("input");
        const addToCartButton = container.querySelector(
          ".product-quick-view-add-to-cart"
        );
        const hideQuickViewButton = container.querySelector(".hide-quick-view");

        // Wishlist Event
        // if (getWishlistBtn) {
        //   container.querySelector('#quick-view-wishlist').addEventListener('click', (event) => {
        //     let count = 0;
        //     let prevState = getWishlistBtn.innerHTML;
        //     getWishlistBtn.click();
        //     let wishlistInterval = setInterval(() => {
        //       console.log('Running: ', prevState, getWishlistBtn.innerHTML);
        //       if (count > 15 || prevState !== getWishlistBtn.innerHTML) {
        //         event.target.innerHTML = getWishlistBtn.innerHTML;
        //         clearInterval(wishlistInterval);
        //       }
        //       count += 1;
        //     }, 500);
        //   })
        // }

        parentVariants.forEach((parentVariant) => {
          parentVariant.addEventListener("click", () => {
            parentVariants.forEach((v) => v.classList.remove("selected"));
            parentVariant.classList.add("selected");
            const parent = parentVariant.parentElement;
            const childrenContainer = parent.nextElementSibling;
            if (product.options[1]?.name) {
              childrenContainer.innerHTML = `<dt>${product.options[1]?.name}</dt>`;
            }
            renderChildVariants(
              product.options,
              product.variants,
              parentVariant.dataset.option.trim(),
              childrenContainer
            );
          });
        });

        minusButton.addEventListener("click", () =>
          changeQuantity(quantity - 1)
        );
        plusButton.addEventListener("click", () =>
          changeQuantity(quantity + 1)
        );
        input.addEventListener("input", (e) =>
          changeQuantity(Number(e.target.value))
        );
        hideQuickViewButton.addEventListener("click", removeElement);

        addToCartButton.addEventListener("click", () => {
          addToCartButton.setAttribute("disabled", "true");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          config.body = JSON.stringify({ id: selectedVariantId, quantity });

          fetch(routes.cart_add_url, config)
            .then((res) => res.json())
            .then((state) => {
              addToCartButton.removeAttribute("disabled");

              if (state.status) {
                const error = container.querySelector(
                  ".quick-view-error-message"
                );
                error.classList.remove("invisible");
                setTimeout(() => error.classList.add("invisible"), 3000);
                return;
              }

              Sidecart.setAsVisible(state);
            });
        });

        function changeQuantity(qty) {
          if (qty > 0 && qty < 100) quantity = qty;
          input.value = qty;
        }
      }
    } else {
      container.innerHTML = `<div class="product-quick-view-loader"></div>`;
    }

    const existingWrapper = document.querySelector(
      ".product-quick-view-wrapper"
    );
    const existingOverlay = document.querySelector(
      ".product-quick-view-overlay"
    );

    if (!!existingWrapper && !!existingOverlay) {
      existingWrapper.remove();
      existingOverlay.remove();
    }

    document.body.appendChild(overlay);
    document.body.appendChild(container);
    document.body.style.overflow = "hidden";

    function removeElement() {
      overlay.remove();
      container.remove();
      document.body.style.overflow = "auto";
    }
  }
}

// get the viewport height for compatibility with iphone
function handleViewportHeight() {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

// handle search bar if the button is clicked yet still not toggled
function handleSearchbarToggle() {
  const toggler = document.getElementById("search-bar-toggle");
  const modal = document.querySelector(".header__search > details");

  toggler.addEventListener("click", function () {
    const isOpen = modal.getAttribute("open");

    if (isOpen !== true) {
      setTimeout(function () {
        modal.setAttribute("open", true);
      }, 250);
    }
  });
}

// handle announcement bar flicker animation
function handleAnnouncementBarAnimation() {
  const wrapper = document.getElementById("announcement-bars-wrapper");
  const announcementBars = wrapper.querySelectorAll("div.announcement-bar");

  if (announcementBars.length < 2) return;

  const interval = Number(wrapper.dataset.animationSpeed);
  let index = -1;

  const playAnimation = () => {
    index += 1;
    if (index > announcementBars.length - 1) index = 0;

    announcementBars.forEach((bar) => bar.classList.remove("visible"));
    announcementBars[index].classList.add("visible");

    setTimeout(() => requestAnimationFrame(playAnimation), interval * 1000);
  };

  requestAnimationFrame(playAnimation);
}

function handleVariantsSorting(cb) {
  const parentProductVariants = document.querySelectorAll(
    "variant-radios > fieldset:first-child > label"
  );

  if (!parentProductVariants?.length) return;

  const sizes = getSortingSizes();

  const handleSorting = () => {
    const childProductVariants = document.querySelectorAll(
      "variant-radios > fieldset:nth-child(2) > label"
    );

    const parent = childProductVariants[0].parentElement;

    const sortedSizes = [];

    childProductVariants.forEach((childVariant) => {
      const size = childVariant.childNodes[0].textContent.trim().toLowerCase();

      let index = sizes.findIndex((r) => String(r?.size)?.toLowerCase() === size);

      if (index < 0) {
        index = sizes.findIndex((r) => String(r?.alias)?.toLowerCase() == size);
      }

      if (index < 0) return;

      sortedSizes.push({
        index,
        elements: [childVariant.previousElementSibling, childVariant],
      });
    });

    childProductVariants.forEach((v) => {
      v.previousElementSibling.remove();
      v.remove();
    });

    sortedSizes
      .sort((a, b) => a.index - b.index)
      .forEach(({ index, elements }) => {
        const [input, label] = elements;
        const text = label.childNodes[0].textContent;

        label.childNodes[0].textContent = sizes[index]?.alias || text;

        parent.appendChild(input);
        parent.appendChild(label);
      });
  };

  // parentProductVariants.forEach((parentVariant) => {
  //   parentVariant.addEventListener("click", handleSorting);
  // });

  handleSorting();
}

function getSortingSizes() {
  return [
    {
      size: "XXS",
      alias: null,
    },
    {
      size: "XS",
      alias: null,
    },
    {
      size: "S",
      alias: null,
    },
    {
      size: "SM",
      alias: null,
    },
    {
      size: "M",
      alias: null,
    },
    {
      size: "L",
      alias: null,
    },
    {
      size: "LXL",
      alias: null,
    },
    {
      size: "XL",
      alias: null,
    },
    {
      size: "XXL",
      alias: null,
    },
    {
      size: "XXXL",
      alias: null,
    },
    {
      size: "4XL",
      alias: null,
    },
    {
      size: "5XL",
      alias: null,
    },
    {
      size: "6XL",
      alias: null,
    },
    {
      size: "ONESI",
      alias: "One Size",
    },
    {
      size: 5.5,
      alias: null,
    },
    {
      size: 6,
      alias: null,
    },
    {
      size: 6.5,
      alias: null,
    },
    {
      size: 7,
      alias: null,
    },
    {
      size: 7.5,
      alias: null,
    },
    {
      size: 8,
      alias: null,
    },
    {
      size: 8.5,
      alias: null,
    },
    {
      size: 9,
      alias: null,
    },
    {
      size: 9.5,
      alias: null,
    },
    {
      size: 10,
      alias: null,
    },
    {
      size: 10.5,
      alias: null,
    },
    {
      size: 11,
      alias: null,
    },
    {
      size: 11.5,
      alias: null,
    },
    {
      size: 12,
      alias: null,
    },
    {
      size: 13,
      alias: null,
    },
    {
      size: 24,
      alias: null,
    },
    {
      size: 25,
      alias: null,
    },
    {
      size: 26,
      alias: null,
    },
    {
      size: 2630,
      alias: null,
    },
    {
      size: 2632,
      alias: null,
    },
    {
      size: 27,
      alias: null,
    },
    {
      size: 2730,
      alias: null,
    },
    {
      size: 2732,
      alias: null,
    },
    {
      size: 28,
      alias: null,
    },
    {
      size: 2830,
      alias: null,
    },
    {
      size: 2832,
      alias: null,
    },
    {
      size: 29,
      alias: null,
    },
    {
      size: 2930,
      alias: null,
    },
    {
      size: 2932,
      alias: null,
    },
    {
      size: 2934,
      alias: null,
    },
    {
      size: 30,
      alias: null,
    },
    {
      size: 3030,
      alias: null,
    },
    {
      size: 3032,
      alias: null,
    },
    {
      size: 3034,
      alias: null,
    },
    {
      size: 31,
      alias: null,
    },
    {
      size: 3130,
      alias: null,
    },
    {
      size: 3132,
      alias: null,
    },
    {
      size: 3134,
      alias: null,
    },
    {
      size: 32,
      alias: null,
    },
    {
      size: 3230,
      alias: null,
    },
    {
      size: 3232,
      alias: null,
    },
    {
      size: 3234,
      alias: null,
    },
    {
      size: 3236,
      alias: null,
    },
    {
      size: 33,
      alias: null,
    },
    {
      size: 3330,
      alias: null,
    },
    {
      size: 3332,
      alias: null,
    },
    {
      size: 3334,
      alias: null,
    },
    {
      size: 3336,
      alias: null,
    },
    {
      size: 34,
      alias: null,
    },
    {
      size: 3430,
      alias: null,
    },
    {
      size: 3432,
      alias: null,
    },
    {
      size: 3434,
      alias: null,
    },
    {
      size: 3436,
      alias: null,
    },
    {
      size: 35,
      alias: null,
    },
    {
      size: 35.5,
      alias: null,
    },
    {
      size: 3530,
      alias: null,
    },
    {
      size: 3532,
      alias: null,
    },
    {
      size: 3534,
      alias: null,
    },
    {
      size: 3536,
      alias: null,
    },
    {
      size: "35-38",
      alias: null,
    },
    {
      size: 36,
      alias: null,
    },
    {
      size: 36.5,
      alias: null,
    },
    {
      size: 3630,
      alias: null,
    },
    {
      size: 3632,
      alias: null,
    },
    {
      size: 3634,
      alias: null,
    },
    {
      size: 3636,
      alias: null,
    },
    {
      size: 37,
      alias: null,
    },
    {
      size: 37.5,
      alias: null,
    },
    {
      size: "37A",
      alias: null,
    },
    {
      size: "37/38",
      alias: null,
    },
    {
      size: 38,
      alias: null,
    },
    {
      size: 38.5,
      alias: null,
    },
    {
      size: "38A",
      alias: null,
    },
    {
      size: "38L",
      alias: null,
    },
    {
      size: 3830,
      alias: null,
    },
    {
      size: 3832,
      alias: null,
    },
    {
      size: 3834,
      alias: null,
    },
    {
      size: 3836,
      alias: null,
    },
    {
      size: 39,
      alias: null,
    },
    {
      size: 39.5,
      alias: null,
    },
    {
      size: "39A",
      alias: null,
    },
    {
      size: "39L",
      alias: null,
    },
    {
      size: "39/40",
      alias: null,
    },
    {
      size: "39-40",
      alias: null,
    },
    {
      size: "39-42",
      alias: null,
    },
    {
      size: 40,
      alias: null,
    },
    {
      size: 4032,
      alias: null,
    },
    {
      size: 4034,
      alias: null,
    },
    {
      size: "40-46",
      alias: null,
    },
    {
      size: "40A",
      alias: null,
    },
    {
      size: "40L",
      alias: null,
    },
    {
      size: 41,
      alias: null,
    },
    {
      size: 41.5,
      alias: null,
    },
    {
      size: "41A",
      alias: null,
    },
    {
      size: "41L",
      alias: null,
    },
    {
      size: "41/42",
      alias: null,
    },
    {
      size: "41-42",
      alias: null,
    },
    {
      size: 42,
      alias: null,
    },
    {
      size: 42.5,
      alias: null,
    },
    {
      size: 4232,
      alias: null,
    },
    {
      size: 4234,
      alias: null,
    },
    {
      size: "42A",
      alias: null,
    },
    {
      size: 43,
      alias: null,
    },
    {
      size: "43A",
      alias: null,
    },
    {
      size: "43/44",
      alias: null,
    },
    {
      size: "43-44",
      alias: null,
    },
    {
      size: "43-46",
      alias: null,
    },
    {
      size: 44,
      alias: null,
    },
    {
      size: "44A",
      alias: null,
    },
    {
      size: 4432,
      alias: null,
    },
    {
      size: 45,
      alias: null,
    },
    {
      size: "45L",
      alias: null,
    },
    {
      size: "45/46",
      alias: null,
    },
    {
      size: "45-46",
      alias: null,
    },
    {
      size: 46,
      alias: null,
    },
    {
      size: 4632,
      alias: null,
    },
    {
      size: 4832,
      alias: null,
    },
    {
      size: "46C",
      alias: null,
    },
    {
      size: 47,
      alias: null,
    },
    {
      size: "47-48",
      alias: null,
    },
    {
      size: "47-50",
      alias: null,
    },
    {
      size: 48,
      alias: null,
    },
    {
      size: "48C",
      alias: null,
    },
    {
      size: 50,
      alias: null,
    },
    {
      size: "50C",
      alias: null,
    },
    {
      size: 52,
      alias: null,
    },
    {
      size: "52C",
      alias: null,
    },
    {
      size: 54,
      alias: null,
    },
    {
      size: "54C",
      alias: null,
    },
    {
      size: 56,
      alias: null,
    },
    {
      size: "56C",
      alias: null,
    },
    {
      size: 58,
      alias: null,
    },
    {
      size: 60,
      alias: null,
    },
    {
      size: 62,
      alias: null,
    },
    {
      size: 64,
      alias: null,
    },
    {
      size: 66,
      alias: null,
    },
    {
      size: 80,
      alias: null,
    },
    {
      size: 85,
      alias: null,
    },
    {
      size: 90,
      alias: null,
    },
    {
      size: 94,
      alias: null,
    },
    {
      size: 95,
      alias: null,
    },
    {
      size: 98,
      alias: null,
    },
    {
      size: 100,
      alias: null,
    },
    {
      size: 102,
      alias: null,
    },
    {
      size: 105,
      alias: null,
    },
    {
      size: 106,
      alias: null,
    },
    {
      size: 110,
      alias: null,
    },
    {
      size: 115,
      alias: null,
    },
    {
      size: 120,
      alias: null,
    },
  ];
}

// DOMContentLoaded listener
window.addEventListener("DOMContentLoaded", () => {
  handleAnnouncementBarAnimation();
  handleNavigationBarCollectionDropdownPosition();
  handleCollectionAnchorTags();
  handleCollectionFacetAnimationOnScroll();
  // handleIfHomepageSectionExistsOnScreen();
  // handleIfHomepageSingleScreen();
  handleCustomVideoResponsiveness();
  handleProductQuickView();
  handleViewportHeight();
  handleSearchbarToggle();
  // handleVariantsSorting();
  Sidecart?.setEventListeners();
});
// We listen to the resize event
window.addEventListener("resize", () => {
  handleViewportHeight();
});

// uppercase a string
function stringToUppercase(str) {
  const arr = str.split(" ");

  //loop through each element of the array and capitalize the first letter.

  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }

  //Join all the elements of the array back into a string
  //using a blankspace as a separator
  const str2 = arr.join(" ");

  return str2;
}

// multicolumn-v2.liquid
class MulticolumnV2 extends HTMLElement {
  /** @type {NodeListOf<HTMLImageElement>} */
  allImageBlocks = [];

  constructor() {
    super();

    window.addEventListener("load", () => this.onDOMContentLoaded());
  }

  onDOMContentLoaded() {
    if (window.innerWidth > 750) {
      this.handleImagesPlayState();
    } else {
      this.handleImagesPlayStateOnSmallerScreens();
    }
  }

  handleImagesPlayState() {
    setTimeout(() => {
      this.allImageBlocks = this.querySelectorAll(".images-block");

      this.allImageBlocks.forEach((block) => {
        let imgs = block.querySelectorAll("img");
        if (imgs.length < 2) return;

        const duplicateImg = document.createElement("img");
        const lastImg = imgs[imgs.length - 1];

        duplicateImg.src = lastImg.src;
        duplicateImg.srcset = lastImg.srcset;

        block.prepend(duplicateImg);

        imgs = block.querySelectorAll("img");

        block.style.width = imgs.length * 100 + "%";

        imgs.forEach((img) => {
          img.style.width = 100 / imgs.length + "%";
          img.style.marginInlineEnd = -1 * (imgs.length / 10) + "rem";
          img.style.padding = `0 ${imgs.length / 20}rem`;
        });

        const handleCurrentBlockPosition = (i) => {
          block.style.marginInlineStart = `calc(-100% * ${i})`;
        };

        let index = 1;
        handleCurrentBlockPosition(index);

        function animationLoop() {
          if (index + 1 >= imgs.length) {
            index = 1;

            const blockTransition = block.style.transition;
            block.style.transition = "unset";
            handleCurrentBlockPosition(0);

            setTimeout(() => {
              block.style.transition = blockTransition;
              handleCurrentBlockPosition(index);
            }, 5);
          } else {
            index += 1;
            handleCurrentBlockPosition(index);
          }

          playAnimation();
        }

        function playAnimation() {
          setTimeout(() => {
            requestAnimationFrame(animationLoop);
          }, Number(block.dataset.intervalSpeed) * 1000);
        }

        playAnimation();
      });
    });
  }

  handleImagesPlayStateOnSmallerScreens() {
    setTimeout(() => {
      const imageBlocks = this.querySelectorAll(".images-block");

      if (imageBlocks.length === 0) return;

      const images = [];

      imageBlocks.forEach((block) => {
        const imgElements = block.querySelectorAll("img");

        if (imgElements.length === 0) return;

        imgElements.forEach((el) =>
          images.push({ src: el.src, srcset: el.srcset })
        );
      });

      if (imageBlocks.length === 3) {
        imageBlocks[2].parentElement.remove();
        imageBlocks[1].parentElement.remove();
      } else if (imageBlocks.length === 2) {
        imageBlocks[1].parentElement.remove();
      }

      const imageBlock = imageBlocks[0];

      while (imageBlock.firstElementChild) {
        imageBlock.firstElementChild.remove();
      }

      images.unshift(images[images.length - 1]);
      images.forEach((image) => {
        const img = document.createElement("img");
        img.src = image.src;
        img.srcset = image.srcset;
        imageBlock.appendChild(img);
      });

      const allImgElements = imageBlock.querySelectorAll("img");

      if (allImgElements.length === 0) return;

      allImgElements.forEach((el) => {
        el.style.width = `${100 / allImgElements.length}%`;
      });

      imageBlock.style.width = `${100 * allImgElements.length}%`;

      const handleCurrentBlockPosition = (i) => {
        imageBlock.style.marginInlineStart = `calc(-100% * ${i})`;
      };

      let index = 1;
      handleCurrentBlockPosition(index);

      function animationLoop() {
        if (index + 1 >= images.length) {
          index = 1;

          const imageBlockTransition = imageBlock.style.transition;
          imageBlock.style.transition = "unset";
          handleCurrentBlockPosition(0);

          setTimeout(() => {
            imageBlock.style.transition = imageBlockTransition;
            handleCurrentBlockPosition(index);
          }, 5);
        } else {
          index += 1;
          handleCurrentBlockPosition(index);
        }

        playAnimation();
      }

      function playAnimation() {
        setTimeout(() => {
          requestAnimationFrame(animationLoop);
        }, Number(imageBlock.dataset.intervalSpeed) * 1000);
      }

      playAnimation();
    });
  }
}
customElements.define("multicolumn-v2", MulticolumnV2);

// image-banner-v2.liquid
class ImageBannerV2 extends HTMLElement {
  /** @type {HTMLElement[]} */
  allFigureBlocks = [];

  /** @type {number} */
  animationSpeed = 6;

  /** @type {HTMLElement} */
  currentCount = null;

  constructor() {
    super();

    this.allFigureBlocks = Array.from(this.querySelectorAll("figure"));
    this.currentCount = this.querySelector(".current-count");
    this.animationSpeed = Number(this.dataset.animationSpeed);
    this.animationSpeed = isNaN(this.animationSpeed) ? 6 : this.animationSpeed;

    this.handleHeight();
    this.handleAnimation();
  }

  handleHeight() {
    const height = this.allFigureBlocks[0].firstElementChild.offsetHeight;

    this.allFigureBlocks.forEach((figure) => {
      figure.style.height = height + "px";
      figure.firstElementChild.style.height = height + "px";
    });
  }

  handleAnimation() {
    this.currentCount.previousElementSibling.firstElementChild.style.animationDuration = `${this.animationSpeed}s`;

    let index = 0;
    const length = this.allFigureBlocks.length;

    const playAnimation = () => {
      if (index >= length - 1) {
        index = 0;
      } else {
        index += 1;
      }

      this.allFigureBlocks.forEach((figure) => {
        figure.classList.remove("visible");
      });

      this.allFigureBlocks[index].classList.add("visible");
      this.currentCount.textContent = index + 1;
    };

    const animationHandler = () => requestAnimationFrame(playAnimation);

    setInterval(animationHandler, this.animationSpeed * 1000);
  }
}
customElements.define("image-banner-v2", ImageBannerV2);

// handle row column animation on scroll in the homepage
function handleIfHomepageInnerSectionExistsOnScreen() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr" ||
    location.pathname === "/pages/hugo" ||
    location.pathname === "/pages/boss"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll("slider-component ul");
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const innerSections = entry.target.querySelectorAll(".single-reveal");
        if (innerSections.length === 0) return;

        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-reveal-${scrollingFrom.top ? "top" : "bottom"}`;
        innerSections.forEach((section, key) => {
          setTimeout(() => {
            section.classList.add(_class);
            setTimeout(() => {
              section.classList.remove(_class);
            }, 1000);
          }, (40 * key));
        });
        shownSections.push(entry.target);
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      const innerSections = section.querySelectorAll(".single-reveal");
      if (innerSections.length > 0) {
        observer.observe(section);
        // prevent animation if section is already visible on screen
        const position = section.getBoundingClientRect();
        if (position.top < window.innerHeight && position.bottom >= 0) {
          shownSections.push(section);
        }
      }
    });
  }
}

// handle signle banner animation on scroll in the homepage
function handleIfHomepageSingleReveal1() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll(".single-reveal-1");
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-reveal1-${scrollingFrom.top ? "top" : "bottom"}`;
        entry.target.classList.add(_class);
        setTimeout(() => {
          entry.target.classList.remove(_class);
        }, 1000);
        shownSections.push(entry.target);
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);
      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// handle 2 row banners animation on scroll in the homepage
function handleIfHomepageSingleReveal2() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll(".single-reveal-2");
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-reveal2-${scrollingFrom.top ? "top" : "bottom"}`;
        entry.target.classList.add(_class);
        setTimeout(() => {
          entry.target.classList.remove(_class);
        }, 1000);
        shownSections.push(entry.target);
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);
      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// handle 3 row banners animation on scroll in the homepage
function handleIfHomepageSingleReveal3() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll("slider-component ul");
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const innerSections = entry.target.querySelectorAll(".single-reveal-3");
        if (innerSections.length === 0) return;
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-reveal3-${scrollingFrom.top ? "top" : "bottom"}`;
        innerSections.forEach((section, key) => {
          section.classList.add(_class);
          setTimeout(() => {
            section.classList.remove(_class);
          }, 1000);
        });
        shownSections.push(entry.target);
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);
      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// handle slider single section animation on scroll in the homepage
function handleIfHomepageSingleRevealSlider() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll(".single-reveal-slider");
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-reveal-slider-${scrollingFrom.top ? "top" : "bottom"}`;
        entry.target.classList.add(_class);
        setTimeout(() => {
          entry.target.classList.remove(_class);
        }, 1000);
        shownSections.push(entry.target);
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);
      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// handle content single section animation on scroll in the homepage
function handleIfHomepageSingleRevealContent() {
  if (
    location.pathname === "/" ||
    location.pathname === "/ar" ||
    location.pathname === "/fr"
  ) {
    document.getElementById("MainContent").style.marginTop =
      -1 * document.getElementById("main-header").offsetHeight + "px";

    let shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll(".single-reveal-content");
    if (sections.length === 0) return;

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-reveal-content-${scrollingFrom.top ? "top" : "bottom"}`;
        entry.target.classList.add(_class);
        setTimeout(() => {
          entry.target.classList.remove(_class);
        }, 1000);
        shownSections.push(entry.target);
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);
      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// Handle Wishlist Button Click Events for Wishlist Club App Button Product Page
function handleWishlistButtonClick() {
  const button = document.querySelector('.product__wishlist-button');
  if (button) {
    const wishlistButton = button.querySelector('.th_wl_button');
    if (wishlistButton) {
      button.addEventListener('click', function(e) {
        wishlistButton.click();
      });
    }
  }
}

// Cart Icon Handler
function handleCartIconDrawer() {
  let btn = document.querySelector('.cart--drawer-btn');
  if (btn) {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      Sidecart.toggleVisibility();
    });
  }
}

// Reward App Custom Handler
function handleRewardAppCustom() {
  // Check until the element is available
  let rewardAppInterval = setInterval(() => {
    let rewardApp = document.querySelector('#app-kr');
    if (rewardApp) {
      let headerTooltipContainer = document.querySelector('#tooltip--reward');
      let customerId = headerTooltipContainer.dataset.customerId;
      if (customerId !== '') {
        let rewardAppPoint = rewardApp.querySelector('.balance-wrapper-kr');
        if (rewardAppPoint) {
          let trimPointText = rewardAppPoint.innerText.trim();
          if (headerTooltipContainer) {
            headerTooltipContainer.innerText = `You have ${trimPointText} Points, redeem now here!`;
          }
        } else {
          if (headerTooltipContainer) {
            headerTooltipContainer.innerText = `You have 0 Points, redeem now here!`;
          }
        }
      }
      headerTooltipContainer.classList.add('active');
      clearInterval(rewardAppInterval);
    }
  }, 250);
}

// DOMContentLoaded listener
window.addEventListener("DOMContentLoaded", () => {
  handleIfHomepageInnerSectionExistsOnScreen();
  handleIfHomepageSingleReveal1();
  handleIfHomepageSingleReveal2();
  handleIfHomepageSingleReveal3();
  handleIfHomepageSingleRevealSlider();
  handleIfHomepageSingleRevealContent();
  // Other methods
  handleWishlistButtonClick();
  handleCartIconDrawer();
  handleRewardAppCustom();
});
